import ActionConstants from '../actionConstants/loader';
export const toggleLoader = (value) => ({
  value,
  type: ActionConstants.TOGGLE_LOADER
});